import { ICON_PFADE, type IconName } from '../icons';

export { ICON_NAMEN, ICON_TEXTE, type IconName } from '../icons';

/** Strich-Icon 24×24 in currentColor – ohne zusätzliche Abhängigkeit. */
export function Icon(props: { name: IconName; size?: number; className?: string }) {
  return (
    <svg
      className={props.className}
      width={props.size ?? 24}
      height={props.size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={ICON_PFADE[props.name]} />
    </svg>
  );
}
